export default "__VITE_ASSET__ll0p58XH__"